import { URL_BOOKING_BUSINESS } from "../../helpers/endpoint";
import { baseBackend } from "../base/baseUrl";

export const getBookingBusiness = async (token) => {
  return await baseBackend.get(URL_BOOKING_BUSINESS, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getBookingBusinessV2 = async ({ start, end }) => {
  return await baseBackend.get(`${URL_BOOKING_BUSINESS}-v2`, {
    params: {
      start,
      end,
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getBookingEnterpriseFilters = async (filters) => {
  return await baseBackend.post(
    "/api/v2/booking/enterprise/filters",
    JSON.stringify(filters),
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const getBookingEnterpriseEmployees = async () => {
  return await baseBackend.get("/api/v2/booking/enterprise/employees", {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getBookingBusinessByID = async (token, id) => {
  return await baseBackend.get(`${URL_BOOKING_BUSINESS}/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createBookingBusiness = async (token, booking) => {
  return await baseBackend.post(
    URL_BOOKING_BUSINESS,
    JSON.stringify({ booking }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const updateBookingBusiness = async (token, booking) => {
  return await baseBackend.put(
    URL_BOOKING_BUSINESS,
    JSON.stringify({ booking }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const updateBookingBusinessCredit = async (token, booking) => {
  return await baseBackend.put(
    `${URL_BOOKING_BUSINESS}-credit`,
    JSON.stringify({ booking }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const updateBookingBusinessSubRoutes = async (booking) => {
  return await baseBackend.put(
    "/api/v1/booking-busines-sub-routes",
    JSON.stringify(booking),
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const putBookingBusiness = async (
  token,
  discount,
  payment_type,
  order,
) => {
  return await baseBackend.put(
    `${URL_BOOKING_BUSINESS}/status`,
    JSON.stringify({
      discount,
      payment_type,
      order,
    }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const updateBookingInvoice = async (token, keys) => {
  return await baseBackend.put(
    `${URL_BOOKING_BUSINESS}/invoice`,
    JSON.stringify({ keys }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

//aun no funciona
export const updateStatusBookingBusiness = async (token, booking) => {
  return await baseBackend.put(
    `${URL_BOOKING_BUSINESS}/statusPayment`,
    JSON.stringify({ booking }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
//aun no funciona
export const updateStatusBookingBusinessAdmin = async (
  token,
  state_payment,
  id,
) => {
  return await baseBackend.put(
    `${URL_BOOKING_BUSINESS}/status_Payment`,
    JSON.stringify({ state_payment, id }),
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const updateBusinessTravelStatus = async (id, travelStatus) => {
  return await baseBackend.put(
    `${URL_BOOKING_BUSINESS}-travel`,
    JSON.stringify({ id, travelStatus }),
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const getHistoryBookingBusiness = async (token, filter) => {
  const apiHistory = `/api/v1/booking-business-filter`;
  return await baseBackend.get(`${apiHistory}?filter=${filter}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};
